/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, SAISON){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	// バナー
	const bnrSlide = () => {
		if($('.idx-bnr-slider').length) {
			$('.idx-bnr-slider').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 4,
				arrows: true,
				dots: false,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							dots: true,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							dots: true,
						}
					}
				]
			});
		}
	};

	// mainVis
	const mainVisSlide = () => {
		if($('.idx-mainVis-slider').length) {
			$('.idx-mainVis-slider').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		}
	};
	// TOPICS
	const topicsSlide = () => {
		if($('.idx-topicsList-slider').length) {
			$('.idx-topicsList-slider').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
						}
					}
				]
			});
		}
	};

	// CSVのデータを描画
	// セゾン・バンガード・グローバルバランスファンド
	const csvLoadGlobal = () => {
		const req = new XMLHttpRequest();
		req.open('get', '/fund/global/status/past_navs1.csv', true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			if(tmp[tmp.length -1] === '') {
				tmp.pop();
			}

			// 最新データ
			const latestData = tmp[tmp.length -1];
			const prevData = tmp[tmp.length -2];
			let date = latestData.split(',')[0].split('/');
			let data1 = Number(latestData.split(',')[1]).toLocaleString();
			let data2 = Number(latestData.split(',')[2]).toLocaleString();
			let data3 =  Number(latestData.split(',')[3]).toLocaleString();
			let prevData1 = Number(prevData.split(',')[1]).toLocaleString();
			let data2Percentage = (parseInt(data1.replace(',', '')) / parseInt(prevData1.replace(',', '')) -1)*100;
			let data2PercentageTxt = Math.round(data2Percentage * 100) / 100;
			
			if(String(data2PercentageTxt).charAt(0) !== '-') {
				data2PercentageTxt = '+' + String(data2PercentageTxt);
			}

			if(data2.charAt(0) !== '-') {
				data2 = '+' + data2;
			}

			$('.js-statusTbl01-global').find('.js-csv-date').text(date[0] +'年'+ date[1] +'月'+ date[2] +'日');
			$('.js-statusTbl01-global').find('.js-csv-data1').text(data1);
			$('.js-statusTbl01-global').find('.js-csv-data2').text(data2);
			$('.js-statusTbl01-global').find('.js-csv-data2-per').text('('+ data2PercentageTxt +'%)');
			$('.js-statusTbl01-global').find('.js-csv-data3').text(data3);
		};
	};
	// セゾン資産形成の達人ファンド
	const csvLoadMaster = () => {
		const req = new XMLHttpRequest();
		req.open('get', '/fund/master/status/past_navs2.csv', true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			if(tmp[tmp.length -1] === '') {
				tmp.pop();
			}

			// 最新データ
			const latestData = tmp[tmp.length -1];
			const prevData = tmp[tmp.length -2];
			let date = latestData.split(',')[0].split('/');
			let data1 = Number(latestData.split(',')[1]).toLocaleString();
			let data2 = Number(latestData.split(',')[2]).toLocaleString();
			let data3 =  Number(latestData.split(',')[3]).toLocaleString();
			let prevData1 = Number(prevData.split(',')[1]).toLocaleString();
			let data2Percentage = (parseInt(data1.replace(',', '')) / parseInt(prevData1.replace(',', '')) -1)*100;
			let data2PercentageTxt = Math.round(data2Percentage * 100) / 100;
			
			if(String(data2PercentageTxt).charAt(0) !== '-') {
				data2PercentageTxt = '+' + String(data2PercentageTxt);
			}

			if(data2.charAt(0) !== '-') {
				data2 = '+' + data2;
			}

			$('.js-statusTbl01-master').find('.js-csv-date').text(date[0] +'年'+ date[1] +'月'+ date[2] +'日');
			$('.js-statusTbl01-master').find('.js-csv-data1').text(data1);
			$('.js-statusTbl01-master').find('.js-csv-data2').text(data2);
			$('.js-statusTbl01-master').find('.js-csv-data2-per').text('('+ data2PercentageTxt +'%)');
			$('.js-statusTbl01-master').find('.js-csv-data3').text(data3);
		};
	};
	// セゾン資産形成の達人ファンド
	const csvLoadJapan = () => {
		const req = new XMLHttpRequest();
		req.open('get', '/fund/japan/status/past_navs3.csv', true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			if(tmp[tmp.length -1] === '') {
				tmp.pop();
			}

			// 最新データ
			const latestData = tmp[tmp.length -1];
			const prevData = tmp[tmp.length -2];
			let date = latestData.split(',')[0].split('/');
			let data1 = Number(latestData.split(',')[1]).toLocaleString();
			let data2 = Number(latestData.split(',')[2]).toLocaleString();
			let data3 =  Number(latestData.split(',')[3]).toLocaleString();
			let prevData1 = Number(prevData.split(',')[1]).toLocaleString();
			let data2Percentage = (parseInt(data1.replace(',', '')) / parseInt(prevData1.replace(',', '')) -1)*100;
			let data2PercentageTxt = Math.round(data2Percentage * 100) / 100;
			
			if(String(data2PercentageTxt).charAt(0) !== '-') {
				data2PercentageTxt = '+' + String(data2PercentageTxt);
			}

			if(data2.charAt(0) !== '-') {
				data2 = '+' + data2;
			}

			$('.js-statusTbl01-japan').find('.js-csv-date').text(date[0] +'年'+ date[1] +'月'+ date[2] +'日');
			$('.js-statusTbl01-japan').find('.js-csv-data1').text(data1);
			$('.js-statusTbl01-japan').find('.js-csv-data2').text(data2);
			$('.js-statusTbl01-japan').find('.js-csv-data2-per').text('('+ data2PercentageTxt +'%)');
			$('.js-statusTbl01-japan').find('.js-csv-data3').text(data3);
		};
	};

	//　ファンド「もっと見る」開閉（TABLET, SP）
	const fundToggle = () => {
		if($('.js-fund-toggle').length) {
			let winW = $(window).width();
			if(winW < 1025) {
				$('.js-fund-toggle').on('click', (e) => {
					let $this = $(e.currentTarget);
					$this.toggleClass(a);
					$this.prev('.idx-fund-txt').slideToggle();
				});
			}
		}
	};

	// TOPメインビジュアル高さ調整
	const mainVis = () => {
		function setHeight(){
			let vh = window.innerHeight * 0.01;
			let fundH = $('.js-fundBlock').outerHeight(true);
			document.documentElement.style.setProperty('--vh', `${vh}px`);
			document.documentElement.style.setProperty('--fund', `${fundH}px`);
		}

		// 2.初期化
		setHeight();

		// 3.ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
		window.addEventListener('resize', setHeight);
	};

	// セミナースライド
	// const seminarSlider = () => {
	// 	$('.js-seminar-slider').slick({
	// 		infinite: true,
	// 		speed: 1000,
	// 		autoplaySpeed: 4000,
	// 		autoplay: true,
	// 		slidesToShow: 3,
	// 		arrows: true,
	// 		dots: true,
	// 		centerMode: true,
	// 		centerPadding: '50px',
	// 		prevArrow: arrowPrev,
	// 		nextArrow: arrowNext,
	// 		responsive: [
	// 			{
	// 				breakpoint: 1024,
	// 				settings: {
	// 					slidesToShow: 1,
	// 				}
	// 			}
	// 		]
	// 	});
	// }
	function pickUpSliderSetting(){
		var width = $(window).width();
		if(width <= 1024) {
			$('.js-seminar-slider').not('.slick-initialized').slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 1,
				arrows: true,
				dots: true,
				centerMode: true,
				centerPadding: '50px',
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
		} else {
			$('.js-seminar-slider.slick-initialized').slick('unslick');
		}
	}

	// 新着動画スライダー
	const movieSlider = () => {
		$('.js-movie-slider').slick({
			infinite: true,
			speed: 1000,
			// autoplaySpeed: 4000,
			autoplay: false,
			slidesToShow: 3,
			arrows: true,
			dots: true,
			centerMode: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	// 画像遅延ロード
	const imglazyLoad = () => {
		document.addEventListener("DOMContentLoaded", function () {
			var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = entry.target;
							lazyImage.src = lazyImage.dataset.src;
							if (typeof lazyImage.dataset.srcset === "undefined") {
							} else {
								lazyImage.srcset = lazyImage.dataset.srcset;
							}
							lazyImage.classList.remove("lazy");
							if(lazyImage.classList.contains("lazy-img")) {
								lazyImage.addEventListener("load", function () {
									let wrapElm = getClosest(lazyImage, "figure.lazy-imgWrap");
									wrapElm.classList.add("is-loaded");
								});
							}
							lazyImageObserver.unobserve(lazyImage);
						}
					});
				}, { rootMargin: "50px" });

				lazyImages.forEach(function (lazyImage) {
					lazyImageObserver.observe(lazyImage);
				});

			} else {
				// Possibly fall back to a more compatible method here
			}
			function getClosest(node, selector) {
				return (node.closest || function (_selector) {
					do {
						if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
							return node;
						}
						node = node.parentElement || node.parentNode;
					} while (node !== null && node.nodeType === 1);

					return null;
				}).call(node, selector);
			}
		});
	};

	// idx-main-buttonAreaを遅延表示
	const buttonArea = () => {
		setTimeout(function() {
			var buttonArea = document.querySelector(".idx-main-buttonArea");
			if (buttonArea) {
				buttonArea.style.visibility = "visible";
				buttonArea.style.opacity = "1";
			}
		}, 5); 
	}
	 

	// =======================================================================================
	bnrSlide();
	mainVisSlide();
	topicsSlide();
	imglazyLoad();
	fundToggle();
	buttonArea ();

	if($('.js-statusTbl01-global').length) {
		csvLoadGlobal();
	}
	if($('.js-statusTbl01-master').length) {
		csvLoadMaster();
	}
	if($('.js-statusTbl01-japan').length) {
		csvLoadJapan();
	}
	if($('.idx-main-img').length) {
		mainVis();
	}
	if($('.js-seminar-slider').length) {
		pickUpSliderSetting();

		$(window).resize(function(){
			pickUpSliderSetting();
		});
	}
	if($('.js-movie-slider').length) {
		movieSlider();
	}

})(window.jQuery, window.SAISON);
